import { format } from 'date-fns';
import { type Locale, enGB, nl } from 'date-fns/locale';

export const getDateLocale = (locale: string): Locale => {
    return locale.startsWith('nl') ? nl : enGB;
};

export const formatDate = {
    // Common date formats
    dayMonth: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'd MMM', { locale: dateLocale });
    },

    dayMonthYear: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'EEE d MMM yyyy', { locale: dateLocale });
    },

    fullDayMonthYear: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'EEEE d MMM yyyy', { locale: dateLocale });
    },

    monthLongWithYear: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'MMMM yyyy', { locale: dateLocale });
    },

    dayShort: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'dd', { locale: dateLocale });
    },

    monthShort: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'MMM', { locale: dateLocale });
    },

    time: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'HH:mm', { locale: dateLocale });
    },

    // For calendar comparison
    compareFormat: (date: Date | string, locale: string): string => {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        const dateLocale = getDateLocale(locale);
        return format(dateObj, 'yyyy-MM-dd', { locale: dateLocale });
    },
};
